// URL pública de cada sección del catálogo. Nuevos y Usados tienen ruta
// limpia (mejor para indexar que ?seccion=); el resto sigue por /lista.
export function urlSeccion(seccion: string): string {
  const s = (seccion || '').trim().toLowerCase();
  if (s === 'nuevos') return '/iphone-nuevos-olavarria';
  if (s === 'usados') return '/iphone-usados-olavarria';
  if (s === 'accesorios') return '/accesorios';
  return `/lista?seccion=${encodeURIComponent(seccion)}`;
}
